import { Page as LibPage } from '@helios/frontend-core';
import { useLocation } from '@tanstack/react-router';
import React, { useContext, useEffect } from 'react';
import useIframeContentHeightMessage from '../../hooks/useIframeContentHeightMessage';
import useIframeScrollWindowMessage from '../../hooks/useIframeScrollWindowMessage';
import { currentPageContext } from '../_app/CurrentPageProvider/currentPageContext';
import { usePageError } from '../_app/PageErrorProvider/usePageError';
import PageError from '../PageError/PageError';

export interface Props {
  className?: string;
  layout: 'grid' | 'singleItem' | 'blank';
  headingLine1?: string;
  headingLine2?: string;
  children: React.ReactNode;
  title?: string;
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  onRetry?: () => void;
  disableContentBottomPadding?: boolean;
}

const Page: React.FC<Props> = (props) => {
  const { onRetry, title, leftContent, rightContent, ...rest } = props;

  const contentRef = React.useRef<HTMLDivElement>(null);
  useIframeScrollWindowMessage(contentRef);
  useIframeContentHeightMessage(contentRef);

  const { setPageTitle, setLeftContent, setRightContent } = useContext(currentPageContext);
  const { hasError } = usePageError();
  const { pathname } = useLocation();

  useEffect(() => {
    setPageTitle(title || '');
    setLeftContent(leftContent ?? null);
    setRightContent(rightContent ?? null);
  }, [title, setPageTitle, pathname]);

  return (
    <LibPage
      {...rest}
      title={title}
      leftContent={leftContent}
      rightContent={rightContent}
      onRetry={onRetry}
      contentRef={contentRef}
      hasError={hasError}
      errorSlot={<PageError onRetry={onRetry} />}
    />
  );
};

export default Page;
